import { useState, useEffect } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { type contributionFilesType } from '..';
import { getContributionFileDetails } from 'service';
import { type GridColumns, type GridValidRowModel } from '@mui/x-data-grid';
import { colorTheme } from 'theme';
import { strings } from 'i18n/Strings';
import { CustomDataGrid } from 'components';
import { commonConstantTexts } from 'constants/constantText';
import { type GridRowData } from 'components/customDataGrid/CustomDataGrid';
import { CurrencyFormaterTwoDecimals } from 'components/helpers/commonFunctions/CurrencyFormater';

interface ContributionFileGridPropsType {
  contributionFile: contributionFilesType;
}
const ContributionFileGrid = (
  props: ContributionFileGridPropsType,
): JSX.Element => {
  const { contributionFile } = props;
  const currentTheme = useTheme();
  const colors = colorTheme(currentTheme.palette.mode);
  const [contributionFileDetails, setContributionFileDetails] = useState([]);
  useEffect(() => {
    if (contributionFile?.id) {
      void getContributionFileDetails(contributionFile.id)
        .then(({ basicInfo }): void => {
          setContributionFileDetails(basicInfo);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [contributionFile]);

  const columns: GridColumns<GridValidRowModel> = [
    {
      field: 'userId',
      flex: 1,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.userId}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row.userId}
        </Typography>
      ),
    },
    {
      field: 'userName',
      flex: 1,
      cellClassName: 'name-column--cell',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.userName}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row?.user?.userName}
        </Typography>
      ),
    },
    {
      field: 'employeeContribution',
      flex: 1,
      cellClassName: 'name-column--cell',
      align: 'right',
      headerAlign: 'center',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.employeeContribution}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {CurrencyFormaterTwoDecimals(Number(row?.employeeContribution))}
        </Typography>
      ),
    },
    {
      field: 'employerContribution',
      flex: 1,
      cellClassName: 'name-column--cell',
      align: 'right',
      headerAlign: 'center',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.employerContribution}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {CurrencyFormaterTwoDecimals(Number(row?.employerContribution))}
        </Typography>
      ),
    },
  ];

  return (
    <Box mt={-5} padding={1}>
      <CustomDataGrid
        columns={columns}
        rows={contributionFileDetails}
        getRowId={(row: GridRowData) => row.contributionRecordId}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0
            ? commonConstantTexts.evenText
            : commonConstantTexts.oddText
        }
      />
    </Box>
  );
};

export default ContributionFileGrid;
